import { useContext, useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import { toast } from 'react-toastify'


const EditItem=({item,handleEdit})=>{

    
    const {updateItem}=useContext(ItemsContext)
    const [title,setTitle]=useState(item.title)
     const [details,setDetails]=useState(item.details)
     const [checked,setChecked]=useState(item.fulfilled)

    
    const handleSubmit=(e)=>{
        e.preventDefault()
        const updatedItem={...item,date:new Date(Date.now()).toLocaleTimeString("cs-CZ"),title,details,fulfilled:checked}
        updateItem(item.id,updatedItem)
        handleEdit(current=>!current)
        toast.success("The item has been UPDATED")
        //setTimeout(()=>alert("The item has been UPDATED."),100)    
      
    }
   
    return(  
        <div className="formEdit">
            <h2>Edit item</h2> 
            <form onSubmit={handleSubmit}>
                <label>Title: </label>
                <input 
                    type="text" 
                    placeholder="Edit a title..." 
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                    required
                />
                <label>Details: </label>
                <textarea
                    placeholder="Edit details..."
                    value={details}
                    onChange={(e)=>setDetails(e.target.value)}
                    required
                    cols="32" rows="3"
                />
                <div>
                <label>Fulfilled: 
                    <input type="checkbox" checked={checked} onChange={()=>setChecked(current=>!current)}/>  
                </label>
                </div>
                <button>Save</button>           
            </form>
        </div>
    )
}

export default EditItem